
import designQuery from "@/apollo/queries/pages/design.gql";
import lenisScrollMixin from '@/mixins/lenisScrollMixin';
import previewModeMixin from '@/mixins/previewModeMixin';
import photoSwipeMixin from '@/mixins/photoSwipe';

export default {
  name: 'design',
  colorMode: 'light',
  mixins: [lenisScrollMixin, previewModeMixin, photoSwipeMixin],
  data() {
    return {
      design: null,
    };
  },
  async asyncData({app, store}) {
    const previewMode = store.state.previewMode;

    if (previewMode) {
      await app.apolloProvider.defaultClient.resetStore();
    }

    const responseDesign = await app.apolloProvider.defaultClient.query({
      query: designQuery,
      variables: {
        locale: app.i18n.locale || 'en',
      },
    }).catch((err) => {
      console.log(JSON.stringify(err, null, 2));
    });

    const design = responseDesign.data?.design;

    return {
      design,
      previewMode,
    };
  },
}
